export default "__VITE_ASSET__B4nmblG5__"